import { useContext } from 'react'
import { JIVE_PRODUCT_ABRS } from '@ucc/unified-admin-common'
import flatten from 'lodash/flatten'
import uniq from 'lodash/uniq'

import { OrganizationContext } from 'components'

const useHasJiveProducts = () => {
  const pbx = useContext(OrganizationContext)

  return uniq(flatten(pbx?.licensesDetails?.results?.map((l) => l.products!))).some((product) =>
    JIVE_PRODUCT_ABRS.includes(product),
  )
}

export default useHasJiveProducts
